module.exports = "<div [chart]=\"chart\" id=\"chart-phase-checker\"></div>\n"